import { useState, useEffect } from 'react';
import { useStoreState, useStoreActions } from '@models/RootStore';

export const useExistingUserFlow = (
  inviteInfo,
  inviteToken,
  expired,
  acceptInvite,
  subCode
) => {
  const isLoggedIn = useStoreState((s) => s.isLoggedIn);
  const currUser = useStoreState((s) => s.users.me);
  const getMe = useStoreActions((a) => a.users.getMe);

  const [showAcceptOptions, setShowAcceptOptions] = useState(false);
  const [inputSubCode, setInputSubCode] = useState(false);

  useEffect(() => {
    if (expired || !currUser || !inviteInfo || !isLoggedIn) {
      return;
    }

    if (currUser?.email?.toLowerCase() === inviteInfo?.email?.toLowerCase()) {
      if (!subCode?.length && inviteInfo?.setSubscription) {
        setInputSubCode(true);
        return;
      }
      acceptInvite(inviteToken, subCode);
      return;
    }

    if (!currUser?.id && inviteInfo?.email) {
      getMe().then((currUser) => {
        if (currUser?.email?.toLowerCase() === inviteInfo?.email?.toLowerCase()) {
          acceptInvite(inviteToken, subCode);
          return;
        }
      });
    }

    if (currUser?.username?.length && currUser?.username !== inviteInfo?.email) {
      setShowAcceptOptions(true);
      return;
    }
  }, [isLoggedIn, expired, inviteInfo, currUser, subCode, inviteToken, getMe, acceptInvite]);

  return {
    showAcceptOptions,
    inputSubCode,
    setShowAcceptOptions,
    setInputSubCode
  };
};
